import '../banners.less';
import './index.less';

import { Col, Row } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';
import Fade from 'react-reveal/Fade';

import USP1 from '../../../../static/svg/workout-usp1.svg';
import USP2 from '../../../../static/svg/workout-usp2.svg';
import USP3 from '../../../../static/svg/workout-usp3.svg';
import Breakpoint from '../../../utils/breakpoint';
import Title from '../../BannerShared/Title';

const TheWorkoutLikeMagic = () => {
  return (
    <div className="banner banner-the-workout-like-magic">
      <div className="container">
        <Breakpoint min="md">
          <div className="ksp-wrapper">
            <div className="ksp-bg">#science</div>
          </div>
        </Breakpoint>
        <Row justify="center">
          <Col xs={24} sm={16} md={18} lg={18} xl={12}>
            <Fade>
              <section style={{ textAlign: 'center' }}>
                <Title title="The Training" isTagline isCenter />
                <Title
                  title="以科学为后盾，<br/>达到魔法般的运动效果"
                  description="研究结果表明：运动效果与你在健身房花费的时间长短无关，而是与你所获得的训练刺激的质量有关。"
                  style={{ marginBottom: '50px' }}
                />
              </section>
            </Fade>
          </Col>
        </Row>
        <Row gutter={[20, 20]}>
          <Col xs={24} sm={24} md={8} lg={8}>
            <Fade>
              <section>
                <div className="banner-the-workout-like-magic__box">
                  <img src={USP1} alt="Burn Fat Faster" />
                  <h3>燃脂</h3>
                  <p>HIIT 可以比传统有氧运动以更快的速度燃脂。</p>
                </div>
              </section>
            </Fade>
          </Col>
          <Col xs={24} sm={24} md={8} lg={8}>
            <Fade>
              <section>
                <div className="banner-the-workout-like-magic__box">
                  <img src={USP2} alt="Increase Endurance" />
                  <h3>增强耐力</h3>
                  <p>进行RITUAL训练有助于提高最大容氧量，从而使您能在更长时间内保持更高运动水平。</p>
                </div>
              </section>
            </Fade>
          </Col>
          <Col xs={24} sm={24} md={8} lg={8}>
            <Fade>
              <section>
                <div className="banner-the-workout-like-magic__box magic__box_3">
                  <img src={USP3} alt="Get Stronger" />
                  <h3>强壮紧实</h3>
                  <p>高强度有氧运动能促进人体生长激素的分泌，从而促进身体形成并保持瘦肌肉。</p>
                </div>
              </section>
            </Fade>
          </Col>
        </Row>
        {/* <Row justify="center">
          <Col xs={24} sm={16} md={18} lg={18} xl={12}>
            <Fade>
              <section>
                <p className="magic-footer" style={{ textAlign: 'center' }}>
                  {t('workout_likemagic_footer')}
                </p>

                <div className="buttons-container">
                  <Link to="/trial/">
                    <Button type="button">{t(`workout_sessioninnumbers_button_startyourritual`)}</Button>
                  </Link>
                </div>
              </section>
            </Fade>
          </Col>
        </Row> */}
      </div>
    </div>
  );
};

TheWorkoutLikeMagic.propTypes = {
  t: PropTypes.func,
};

export default TheWorkoutLikeMagic;
